import { pink } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  buttonG: {
    marginTop: 20
  },
  selected: {
    backgroundColor: pink.A700,
    color: pink[50]
  }
}));
